import IBancoResponse from '../entities/IBancoResponse'
import { IBancoRepository } from '../repositories/IBancoRepository'

export interface IFindBancos {
  execute(): Promise<IBancoResponse[]>
}

export default class FindBancosImpl implements IFindBancos {
  constructor(private readonly bancoRepository: IBancoRepository) {}

  public async execute(): Promise<IBancoResponse[]> {
    const response = await this.bancoRepository.findAll()
    return response
  }
}
